<template>
    <Head>
        <title>Nitro</title>
    </Head>
    <div class="app">
        <div class="wrapper">
            <slot />
        </div>

        <DToaster
            v-if="$page.props.flash.errorMessage"
        >
            <DToast
                :key="'flash'"
                :show="true"
                color="danger"
                header-text="Error"
                :body-text="__($page.props.flash.errorMessage)"
            />
        </DToaster>
    </div>
</template>

<script>

export default {
    name: 'AuthBase',
    mounted () {
        // Apply saved theme preference
        const savedTheme = localStorage.getItem('theme')
        if (savedTheme === 'dark') {
            document.body.classList.add('dark-mode')
        }
    }
}
</script>

<style lang="scss" scoped>
.app {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    overflow-y: auto;
    padding: 50px;
    color: #0a111a;

    .wrapper {
        width: 90%;
        max-width: 600px;
        margin: 0 auto;
    }
}
</style>
